export default "__VITE_ASSET__DTrwsnQd__"